import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-up_real",
  "use": "icon-up_real-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" class=\"icon iconArrow\" id=\"icon-up_real\">\r\n        <path fill=\"#FFFFFF\" fill-rule=\"evenodd\" d=\"M14.724 19.17c.783.784 2.05.788 2.837 0l5.047-5.047c1.173-1.172.776-2.123-.869-2.123H10.545c-1.652 0-2.04.952-.869 2.123l5.048 5.048z\" />\r\n      </symbol>"
});
var result = sprite.add(symbol);
export default symbol